import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { signOut } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import auth from "../../Firebase-Setup/firebase.init";

const CheckoutForm = ({ order }) => {
    const location = useLocation();
    const [verifiedUser, setVerifedUser] = useState(true);
    const [clientSecret, setClientSecret] = useState("");
    const handleSignOut = () => {
        signOut(auth);
        localStorage.removeItem("accessToken");
    };

    const navigate = useNavigate();
    const stripe = useStripe();
    const elements = useElements();
    const [cardErr, setCardErr] = useState("");
    const [orderSuccess, setOrderSuccess] = useState("");
    const [paymentProccessing, setPaymentProccesing] = useState(false);
    const [transId, setTransId] = useState("");
    const { subTotal, buyerName, buyerEmail, _id } = order;
    useEffect(() => {
        fetch("https://elctrofy.herokuapp.com/create-payment-intent", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: JSON.stringify({ subTotal }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data?.clientSecret) {
                    setClientSecret(data.clientSecret);
                } else {
                    setVerifedUser(false);
                }
            });
    }, [navigate, order, setVerifedUser, subTotal]);
    if (verifiedUser === false) {
        handleSignOut();
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!stripe || !elements) {
            return;
        }
        const card = elements.getElement(CardElement);
        if (card === null) {
            return;
        }
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: "card",
            card,
        });

        setCardErr(error?.message || "");
        setOrderSuccess("");
        setPaymentProccesing(true);
        // confirem order payment
        const { paymentIntent, error: intentError } =
            await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: card,
                    billing_details: {
                        name: `${buyerName}`,
                        email: `${buyerEmail}`,
                    },
                },
            });
        if (intentError) {
            setCardErr(intentError?.message);
            setPaymentProccesing(false);
        } else {
            setCardErr("");
            setTransId(paymentIntent.id);

            setOrderSuccess("Congrat your paymet is successfull.");

            // upadate payment info on the database

            const paymet = {
                orderId: _id,
                transactionId: paymentIntent.id,
            };
            fetch(`https://elctrofy.herokuapp.com/order/${_id}`, {
                method: "PATCH",
                headers: {
                    "content-type": "application/json",
                    authorization: `Bearer ${localStorage.getItem(
                        "accessToken"
                    )}`,
                },
                body: JSON.stringify(paymet),
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data?.acknowledged) {
                        setPaymentProccesing(false);
                        toast.success(`${buyerName} Your order is Success.`);
                    }
                });
        }
    };
    return (
        <>
            <form onSubmit={handleSubmit}>
                <CardElement
                    options={{
                        style: {
                            base: {
                                fontSize: "16px",
                                color: "#424770",
                                "::placeholder": {
                                    color: "#aab7c4",
                                },
                            },
                            invalid: {
                                color: "#9e2146",
                            },
                        },
                    }}
                />
                <button
                    type="submit"
                    disabled={!stripe || !clientSecret || orderSuccess}
                    className="btn h-16 w-full rounded-sm bg-indigo-600 tracking-wide font-semibold text-white"
                >
                    Pay
                </button>
            </form>
            <p className="text-warning">{cardErr}</p>
            {paymentProccessing && (
                <p className="text-center text-blue-500">Loading....</p>
            )}
            {orderSuccess && (
                <p className="text-green-500 text-center">{orderSuccess}</p>
            )}
            {transId && (
                <div>
                    <div>
                        <div>
                            <svg
                                viewBox="0 0 24 24"
                                className="text-green-600 w-16 h-16 mx-auto my-6"
                            >
                                <path
                                    fill="currentColor"
                                    d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
                                ></path>
                            </svg>
                            <div className="text-center">
                                <p>TransId:{transId}</p>
                                <h3 className="md:text-2xl text-base text-gray-900 font-semibold text-center">
                                    Payment Done!
                                </h3>
                                <p className="text-gray-600 my-2">
                                    Thank you for completing your secure online
                                    payment.
                                </p>
                                <p> Have a great day! </p>
                                <div className="py-10 text-center">
                                    <Link
                                        to="/dashboard/myOrders"
                                        className="px-12 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3"
                                    >
                                        GO BACK
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CheckoutForm;
